<template>
  <div clas="mt-3">
    <mdb-row>
      <mdb-col md="3"><admin-org-tree v-model="org"/></mdb-col>
      <mdb-col md="9"  v-if="org">
        <folder-label label="기관설명" :open="true">
          <!-- <div v-html="$linebreak(org.description)"/> -->
          <mdb-input type="textarea" v-model="org.description" :rows="5"/>
          <mdb-input label="구분명" v-model="org.prefix" class="w-30"/>
          <save-btn-sm @click="onOrgSave" class="mr-2">저장</save-btn-sm>
        </folder-label>
        <hr>
        <div class="clearfix">
          <div class="float-left bolder indigo-text pt-2">
            <mdb-icon  icon="users" /> 관리자 목록
          </div>
          <div class="float-right text-right">
            <mdb-btn icon="user-plus" class=" p-1 pr-2" @click="onAddManager">추가</mdb-btn>
          </div>
        </div>
        <mdb-tbl sm hover>
          <mdb-tbl-head>
            <tr>
              <th>No</th>
              <th>이름</th>
              <th>사용자 Id</th>
              <th>email</th>
              <th>전화번호</th>
              <th style="width:90px"></th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(manager, i) in managers" :key="i">
              <td>{{i+1}}</td>
              <td><a>{{manager.name}}</a></td>
              <td>{{manager.userId}}</td>
              <td>{{manager.email}}</td>
              <td>{{$cellPhone(manager.cellPhone)}}</td>
              <td class="text-right">
                <mdb-btn sm icon="lock" class="m-0 p-0 mr-1" @click="onShowPasswordDlg(manager)"/>
                <mdb-btn sm icon="edit" class="m-0 p-0 mr-1" @click="onEdit(manager)"/>
                <mdb-btn sm icon="user-minus" class="m-0 p-0" color="danger"
                  @click="onDelete(manager)"/>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-col>
    </mdb-row>
    <modal-dlg v-if="modal" icon="plus" title="매니저 추가" :show="modal"  @close="onClose">
      <div class="px-3">
        <div class="clearfix">
          <div class="float-left w-70">
            <mdb-input label="사용자 ID*" v-model="manager.userId" class="my-0" :disabled="!!manager._id"/>
          </div>
          <div class="float-right" v-if="!manager._id">
            <mdb-btn color="primary" class="mt-2 p-1" @click="isexist" :disabled="!manager.userId">ID 중복체크</mdb-btn>
          </div>
        </div>
        <div  v-if="!manager._id" :class="{'red-text' : !idcheck}">{{checkMessage}}</div>
        <mdb-input label="이름*" v-model="manager.name"/>
        <mdb-input v-if="!manager._id" type="password" label="비밀번호*" v-model="manager.password" class="w-50"/>
        <mdb-input v-if="!manager._id" type="password" label="비밀번호 확인*" v-model="password2" class="w-50"/>
        <mdb-input label="email*" v-model="manager.email" class="w-50"/>
        <mdb-input label="전화번호(010-xxxx-xxxx)" v-model="cellPhone" class="w-50"/>
      </div>
      <div class="text-center">
        <mdb-btn class="py-2" color="primary" @click="onSave" :disabled="!isOk">저장</mdb-btn>
        <mdb-btn class="py-2" @click="onClose">닫기</mdb-btn>
      </div>
    </modal-dlg>
    <modal-dlg v-if="passwordModal" size="sm" icon="lock" title="비빌번호 변경" :show="passwordModal"  @close="modal=false">
      <div>
        <mdb-input type="password" label="새 비밀번호" v-model="newPassword"/>
        <mdb-input type="password" label="새 비밀번호 확인" v-model="newPassword2"/>
      </div>
      <div class="text-center">
        <mdb-btn class="py-2 mr-3" color="primary" @click="onChangePassword">변경</mdb-btn>
        <mdb-btn class="py-2" @click="passwordModal=false">닫기</mdb-btn>
      </div>
    </modal-dlg>
  </div>
</template>
<script>
import { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import TrainingIntro from '@/components/training/TrainingIntro.vue';
import AdminOrgTree from '../../../../components/admin/AdminOrgTree.vue';
import FolderLabel from '../../../../components/common/FolderLabel.vue';
import Member from '@/models/Member'
import { compare } from '@/utils/util'
export default {
  // name: 'AdminOrgPage',
  components: { AdminOrgTree, FolderLabel },
  props: [],
  data: () => ({
    org: '',
    managers: [],
    modal: false,
    manager: {},
    idcheck: false,
    cellPhone: '',
    password2: '',
    checkMessage: 'ID 중복 체크를 해야 합니다.',
    passwordModal: false,
    newPassword: '',
    newPassword2: ''
  }),
  computed: {
    ...mapState('auth', ['profile']),
    isOk () {
      if (this.manager._id) {
        return this.manager.name && this.manager.email
      } else {
        return this.manager.userId && this.manager.password && this.password2 && this.idcheck && this.manager.name && this.manager.email
      }
    }
  },
  methods: {
    ...mapActions('auth', ['changePasswordByStaff']),
    async onDelete (arg) {
      if (!confirm('삭제할까요?')) return
      await arg.delete()
      this.managers = this.managers.filter(e => e !== arg)
    },
    async isexist () {
      if (!this.manager.userId) {
        return alert('사용자 ID를 입력하세요.')
      }
      const { exists } = await this.$Auth.isexist(this.manager.userId)
      if (exists) {
        this.checkMessage = this.manager.userId + '는 이미 사용 중인 ID입니다.'
      } else {
        this.checkMessage = '사용 가능한 ID입니다.'
      }
      this.idcheck = !exists
    },
    async onOrgSave () {
      if (!confirm('저장할까요?')) return
      this.org = await this.org.save()
    },
    onAddManager () {
      this.manager = new this.$member({
        org: this.org._id,
        role: 'MANAGER'
      })
      this.modal = true
    },
    onClose () {
      this.modal = false
      this.manager = {}
      this.idcheck = false
      this.cellPhone = ''
      this.checkMessage = 'ID 중복 체크를 해야 합니다.'
    },
    onEdit (manager) {
      this.manager = manager
      if (manager.cellPhone) {
        this.cellPhone = this.$cellPhone(manager.cellPhone)
      }
      this.modal = true
    },
    async onSave () {
      if (!this.manager._id && this.manager.password !== this.password2) {
        alert('비밀번호 확인이 다릅니다.')
        return
      }
      if (this.cellPhone.trim()) {
        const numbers = this.cellPhone.split('-')
        if (numbers.length !== 3) {
          return alert('전화번호 양식이 올바르지 않습니다.')
        }
        this.manager.cellPhone = {
          number1: numbers[0],
          number2: numbers[1],
          number3: numbers[2]
        }
      }
      if (!confirm('저장할까요?')) return
      // this.$emit('join', ?this.manager)
      this.manager = await this.manager.save()
      this.managers.push(this.manager)
      this.managers = this.managers.sort((m1, m2) => compare(m1.name, m2.name))
      this.onClose()
    },
    async onChangePassword () {
      if (this.newPassword !== this.newPassword2) {
        alert('비밀번호 확인이 다릅니다.')
        return
      }
      await this.changePasswordByStaff({
        _id: this.manager._id,
        newPassword: this.newPassword
      })
      alert('비밀번호가 변경되었습니다.')
      this.passwordModal = false
      this.newPassword = ''
      this.newPassword2 = ''
    },
    onShowPasswordDlg (manager) {
      this.passwordModal = true
      this.newPassword = ''
      this.newPassword2 = ''
      this.manager = manager
    }
  },
  watch: {
    async org () {
      this.managers = await Member.managerList(this.org._id)
    }
  }
}
</script>
